import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="item-image-uploader"
export default class extends Controller {
  static targets = ["input", "dropzone", "preview", "filename"]

  connect() {
  }

  // 클릭하면 파일 선택창
  openPicker() {
    this.inputTarget.click()
  }

  // <input type="file">에서 선택된 경우
  choose(e) {
    const file = e.target.files?.[0]
    if (file) this._useFile(file)
  }

  // 드래그 앤 드롭
  dragOver(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.add("ring-2", "ring-primary", "bg-primary/5")
  }

  dragLeave(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.remove("ring-2", "ring-primary", "bg-primary/5")
  }

  drop(e) {
    e.preventDefault()
    this.dropzoneTarget.classList.remove("ring-2", "ring-primary", "bg-primary/5")
    const file = e.dataTransfer.files?.[0]
    if (file) {
      // 드롭된 파일을 input.files로 주입
      const dt = new DataTransfer()
      dt.items.add(file)
      this.inputTarget.files = dt.files
      this._useFile(file)
      // 필요하면 자동 제출:
      // this.inputTarget.form?.requestSubmit()
    }
  }

  _useFile(file) {
    if (!file.type.startsWith("image/")) return
    this.filenameTarget?.classList.add("hidden")
    // 미리보기
    const reader = new FileReader()
    reader.onload = (ev) => {
      if (this.previewTarget) {
        this.previewTarget.src = ev.target.result
        this.previewTarget.classList.remove("hidden")
        this.previewTarget.classList.add("object-contain")
      }
    }
    reader.readAsDataURL(file)
  }
}
